import { AuthCaseManager } from './AuthCases';

/**
 * Helper utility for determining when to open auth dialogs from the layout
 */
export class AuthDialogHelper {
  constructor() {
    this.authCaseManager = new AuthCaseManager();
  }

  /**
   * Determines if auth dialog should be opened based on current state
   * @param {Object} context - Application context
   * @returns {boolean} - Whether to open auth dialog
   */
  shouldOpenAuthDialog(context) {
    return this.authCaseManager.shouldShowAnyDialog(context);
  }

  /**
   * Gets the reason why auth dialog should be opened (for debugging)
   * @param {Object} context - Application context
   * @returns {string|null} - The case name that triggered the dialog, or null
   */
  getAuthDialogReason(context) {
    const activeCase = this.authCaseManager.getActiveCase(context);
    return activeCase ? activeCase.getCaseName() : null;
  }

  /**
   * Gets debug information about all auth cases
   * @param {Object} context - Application context
   * @returns {Array} - Debug information for all cases
   */
  getDebugInfo(context) {
    return this.authCaseManager.getDebugInfo(context);
  }
}

// Export singleton instance
export const authDialogHelper = new AuthDialogHelper();
